import { pushAnalyticsEvent, OwcTrackingDetails } from '@shared/tracking/trackingService';

export const triggerAnalyticsEvent = async (eventDetail: OwcTrackingDetails): Promise<void> =>
  await pushAnalyticsEvent(eventDetail, process.env.APP_VERSION!);
